(() => {
 'use strict';
 if (window.OutlumiAnalytics) return;
 const endpoint = 'https://outlumi-product-insights.wayneberich888.chatgpt.site/api/events';
 const siteEndpoint=endpoint.replace('/api/events','/api/site-events');
 const permitted=()=>!navigator.globalPrivacyControl&&navigator.doNotTrack!=='1'&&(!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed||window.Shopify.customerPrivacy.analyticsProcessingAllowed());
 let pageTracked=false;
 function trackSite(type,extra={}){if(!permitted())return;void fetch(siteEndpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({eventId:randomId(),sessionId,type,...extra}),keepalive:true}).catch(()=>{});}
 function pageView(){if(!pageTracked&&permitted()){pageTracked=true;trackSite('page_view');}}
 const types = new Set(['card_impression','card_click','product_view','add_to_cart','kakao_click']);
 const randomId = () => crypto.randomUUID();
 let sessionId;
 try { sessionId = sessionStorage.getItem('outlumi-analytics-session');if (!sessionId) { sessionId = randomId();sessionStorage.setItem('outlumi-analytics-session', sessionId); } } catch { sessionId = randomId(); }
 const seen = new Set();
 const day = () => new Date(Date.now()+9*3600000).toISOString().slice(0,10);
 const queue = [];
 let running = false;
 const send = payload => !permitted()?Promise.resolve():fetch(endpoint,{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),keepalive:true}).catch(()=>{});
 async function flush() {
  if (running) return;running = true;
  while (queue.length) {
   const payload=queue.shift();
   await send(payload);
   await new Promise(resolve=>setTimeout(resolve,250));
  }
  running=false;
 }
 function track(type, productId) {
  const id=String(productId || '').replace(/^gid:\/\/shopify\/Product\//,'');
  if (!types.has(type)||!/^\d+$/.test(id)||!permitted()) return;
  const key=day()+'|'+type+'|'+id;
  if (['card_impression','product_view'].includes(type)) {if(seen.has(key))return;seen.add(key);}
  if(queue.length>=100)return;
  const payload={eventId:randomId(),sessionId,type,productId:id};
  // Start user actions immediately so navigation cannot abandon them behind exposures.
  if(type!=='card_impression'){void send(payload);return;}
  queue.push(payload);void flush();
 }
 window.addEventListener('pagehide',()=>{while(queue.length)void send(queue.shift());});
 window.OutlumiAnalytics={track};
 const observed=new WeakSet();
 const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
  entries.forEach(entry=> { if(entry.isIntersecting && entry.intersectionRatio>=0.5){track('card_impression',entry.target.dataset.outlumiProductId);observer.unobserve(entry.target);} });
 },{threshold:0.5}):null;
 function attach(){
  document.querySelectorAll('[data-outlumi-card][data-outlumi-product-id]').forEach(card=>{if(observed.has(card))return;observed.add(card);if(observer)observer.observe(card);});
  document.querySelectorAll('[data-outlumi-product-view][data-outlumi-product-id]').forEach(detail=>track('product_view',detail.dataset.outlumiProductId));
 }
 document.addEventListener('click',event=>{
  const element=event.target instanceof Element?event.target:null;if(!element)return;
  const kakao=element.closest('a[href]');
  if(kakao){let url;try{url=new URL(kakao.href);}catch{}if(url&&(/(^|\.)kakao\.com$/.test(url.hostname)||/(^|\.)kakao\.to$/.test(url.hostname))){
   const product=kakao.closest('[data-outlumi-product-id]');const productId=kakao.dataset.outlumiProductId||product?.dataset.outlumiProductId;
   const source=kakao.matches('[data-nav-item="kakao"]')?'bottom_nav':kakao.classList.contains('olm-selection-kakao')?'selection':productId?'product':'other';
   trackSite('kakao_click',{source,...(productId?{productId}:{})});
  }}
  const tagged=element.closest('[data-outlumi-track]');
  if(tagged){const product=tagged.closest('[data-outlumi-product-id]');track(tagged.dataset.outlumiTrack,tagged.dataset.outlumiProductId||product?.dataset.outlumiProductId);}
  const link=element.closest('a[data-outlumi-product-link], [data-outlumi-card] a[href*="/products/"]');
  if(link){const card=link.closest('[data-outlumi-card][data-outlumi-product-id]');if(card){track('card_impression',card.dataset.outlumiProductId);track('card_click',card.dataset.outlumiProductId);}}
 });
 const start=()=>{pageView();document.addEventListener('visitorConsentCollected',()=>{pageView();attach();});attach();new MutationObserver(attach).observe(document.body,{childList:true,subtree:true});};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
